// Static data for the HYROX hub page.

export const HYROX_CITIES = [
  { city: 'New York City', slug: 'the-best-hyrox-training-gyms-in-new-york-city-your-complete-directory', state: 'NY' },
  { city: 'Los Angeles', slug: 'the-best-hyrox-training-gyms-in-los-angeles-your-complete-directory', state: 'CA' },
  { city: 'Chicago', slug: 'the-best-hyrox-training-gyms-in-chicago-your-complete-directory', state: 'IL' },
  { city: 'Dallas-Fort Worth', slug: 'the-best-hyrox-training-gyms-in-dallas-fort-worth-your-complete-directory', state: 'TX' },
  { city: 'Houston', slug: 'the-best-hyrox-training-gyms-in-houston-your-complete-directory', state: 'TX' },
  { city: 'Miami', slug: 'the-best-hyrox-training-gyms-in-miami-your-complete-directory', state: 'FL' },
  { city: 'Atlanta', slug: 'the-best-hyrox-training-gyms-in-atlanta-your-complete-directory', state: 'GA' },
  { city: 'Denver', slug: 'the-best-hyrox-training-gyms-in-denver-your-complete-directory', state: 'CO' },
  { city: 'Phoenix', slug: 'the-best-hyrox-training-gyms-in-phoenix-your-complete-directory', state: 'AZ' },
  { city: 'San Francisco', slug: 'the-best-hyrox-training-gyms-in-san-francisco-your-complete-directory', state: 'CA' },
  { city: 'Boston', slug: 'the-best-hyrox-training-gyms-in-boston-your-complete-directory', state: 'MA' },
  { city: 'Nashville', slug: 'the-best-hyrox-training-gyms-in-nashville-your-complete-directory', state: 'TN' },
  { city: 'San Diego', slug: 'the-best-hyrox-training-gyms-in-san-diego-your-complete-directory', state: 'CA' },
  { city: 'Minneapolis', slug: 'the-best-hyrox-training-gyms-in-minneapolis-your-complete-directory', state: 'MN' },
  { city: 'Charlotte', slug: 'the-best-hyrox-training-gyms-in-charlotte-your-complete-directory', state: 'NC' },
  { city: 'Washington D.C.', slug: 'the-best-hyrox-training-gyms-in-washington-dc-your-complete-directory', state: 'DC' },
  { city: 'Austin', slug: 'the-best-hyrox-training-gyms-in-austin-your-complete-directory', state: 'TX' },
  { city: 'Tampa', slug: 'the-best-hyrox-training-gyms-in-tampa-your-complete-directory', state: 'FL' },
  { city: 'Salt Lake City', slug: 'the-best-hyrox-training-gyms-in-salt-lake-city-your-complete-directory', state: 'UT' },
  { city: 'Las Vegas', slug: 'the-best-hyrox-training-gyms-in-las-vegas-your-complete-directory', state: 'NV' },
  { city: 'Portland', slug: 'the-best-hyrox-training-gyms-in-portland-your-complete-directory', state: 'OR' },
  { city: 'Anaheim', slug: 'the-best-hyrox-training-gyms-in-anaheim-your-complete-directory', state: 'CA' },
];

export const HYROX_TOOLS_ICON_NAMES = ['Zap', 'Crosshair', 'Gauge', 'Calculator'];

// HYROX_TOOLS lives in ToolsSection.jsx (needs the icon component refs from lucide)

export const RACE_STATIONS = [
  { name: 'SkiErg', distance: '1,000m', tip: 'Keep a steady pace. Don\'t burn out in the first 200m.' },
  { name: 'Sled Push', distance: '50m', tip: 'Drive from the hips. Short, powerful steps.' },
  { name: 'Sled Pull', distance: '50m', tip: 'Sit low, hand-over-hand. Use your legs.' },
  { name: 'Burpee Broad Jumps', distance: '80m', tip: 'Find your rhythm. Don\'t rush the jumps.' },
  { name: 'Rowing', distance: '1,000m', tip: 'Drive with legs first. Aim for sub-2:00 splits.' },
  { name: 'Farmers Carry', distance: '200m', tip: 'Grip hard, keep your core braced. Walk fast.' },
  { name: 'Sandbag Lunges', distance: '100m', tip: 'Full range of motion. Knee to ground each rep.' },
  { name: 'Wall Balls', distance: '75-100 reps', tip: 'Use your legs to drive the ball. Breathe at the top.' },
];

export const EQUIPMENT = [
  { name: 'Concept2 SkiErg', station: 'Station 1', desc: 'Full-body, low-impact. The first test of your race.', affiliateUrl: 'https://www.concept2.com/skierg', price: '$795' },
  { name: 'Concept2 RowErg', station: 'Station 5', desc: 'PM5 monitor tracks every stroke. The gold standard for rowing.', affiliateUrl: 'https://www.concept2.com/indoor-rowers', price: '$990' },
];

export const GUIDE_SLUGS = [
  'the-ultimate-guide-to-hyrox-training-plans-and-workouts-get-race-ready',
  'hyrox-beginner-guide',
  'hyrox-8-week-training-plan',
  'hyrox-station-strategies',
  'hyrox-nutrition-race-day',
  'hyrox-doubles-strategy',
  'hyrox-race-day-guide',
  'hyrox-skierg-technique',
  'hyrox-sled-push-pull-guide',
  'hyrox-vs-crossfit-comparison',
];

export const NAV_SECTIONS = [
  { id: 'race', label: 'The Race' },
  { id: 'videos', label: 'Videos' },
  { id: 'stations', label: 'Stations' },
  { id: 'raceplan', label: 'Race Plan' },
  { id: 'tools', label: 'Tools' },
  { id: 'guides', label: 'Guides' },
  { id: 'gyms', label: 'Find a Gym' },
  { id: 'equipment', label: 'Equipment' },
  { id: 'affiliate', label: 'Affiliate' },
];

export const VIDEO_CLIPS = [
  { id: 'hyrox-recap', title: 'HYROX Race Recap', cat: 'Race Recap', src: 'https://customer-assets.emergentagent.com/job_a976fb05-21a8-471d-88e2-aad0bf8a8eeb/artifacts/kumi84ge_HYROX%20RECAP.mp4' },
  { id: 'skierg-film', title: 'SkiErg Station', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/heww5odd_Daniel%20and%20Elli%20Individual%20Clips00415387.mov' },
  { id: 'sled-push-film', title: 'Sled Push Station', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/jn8rd8ib_Daniel%20and%20Elli%20Individual%20Clips00421357.mov' },
  { id: 'sled-pull-film', title: 'Sled Pull Station', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/jc2dfn6a_Daniel%20and%20Elli%20Individual%20Clips00424143.mov' },
  { id: 'burpee-film', title: 'Burpee Broad Jump', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/eoeovu73_Daniel%20and%20Elli%20Individual%20Clips00427672.mov' },
  { id: 'rower-film', title: 'Rowing Station', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/g910lzp9_Daniel%20and%20Elli%20Individual%20Clips00433345.mov' },
  { id: 'farmers-carry-film', title: 'Farmers Carry', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/d507xqjq_Daniel%20and%20Elli%20Individual%20Clips00435530.mov' },
  { id: 'sandbag-lunges-film', title: 'Sandbag Lunges', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/mwq1t9or_Daniel%20and%20Elli%20Individual%20Clips00438894.mov' },
  { id: 'wall-balls-film', title: 'Wall Balls', cat: 'Station Mastery', src: 'https://customer-assets.emergentagent.com/job_c7785eb2-bf9f-4901-baad-250c11530aa2/artifacts/y6y9g1i6_Daniel%20and%20Elli%20Individual%20Clips00441135.mov' },
];

export const HYROX_FAQS = [
  { q: 'What is HYROX?', a: 'HYROX is a standardized indoor fitness race combining 8km of running with 8 functional workout stations (SkiErg, Sled Push, Sled Pull, Burpee Broad Jumps, Rowing, Farmers Carry, Sandbag Lunges, Wall Balls). The same format worldwide.' },
  { q: 'How do I prepare for my first HYROX race?', a: 'Start with our 8-Week Training Plan. Focus on building running endurance alongside station-specific strength. Most beginners should target a 1:30-2:00 finish time.' },
  { q: 'What divisions are available?', a: 'Open (Men/Women), Pro (heavier weights), Doubles (2 athletes alternate), Pro Doubles, and Relay (teams of 4).' },
  { q: 'How much does a HYROX race entry cost?', a: 'Race entries typically range from $99-$149 depending on the city and division. Early registration usually offers discounted pricing.' },
  { q: 'Can I do HYROX as a beginner?', a: 'Absolutely. The Open division has manageable weights and many first-timers complete the race. Use our Finish Time Predictor to set realistic goals.' },
];

export const COMPARE_ROWS = [
  { key: 'city', label: 'City' },
  { key: 'rating', label: 'Rating' },
  { key: 'tier', label: 'Affiliation Tier' },
  { key: 'pricing', label: 'Pricing' },
  { key: 'equipment', label: 'Key Equipment' },
  { key: 'hyroxClasses', label: 'HYROX Classes', bool: true },
  { key: 'raceSims', label: 'Race Simulations', bool: true },
  { key: 'notableInfo', label: 'Notable Info' },
  { key: 'address', label: 'Address' },
  { key: 'phone', label: 'Phone' },
];

// Used for the gym name → slug fingerprint that backs share URLs
export const gymToSlug = (g) =>
  `${g.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}__${g.city.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

export const safeId = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');
